import React from 'react';

function CompetitionTeams({ addPlayerToTeam, assignedPlayerIds, availableForTeam, clubTeams, compPlayers, createTeam, deleteTeam, editingTeam, emailPanel, generateTeams, importClubTeam, importableClubTeams, isAdmin, isFinalised, isLocked, newTeamName, openTeamProfile, removePlayerFromTeam, renameTeam, selectedComp, selectedCompDiscipline, setActiveStep, setEditingTeam, setNewTeamName, setTeamPlayerPick, teamPlayerPick, teams, togglePaid, users }) {
  return (
    <div className="w3-card w3-round w3-white w3-margin-top">
      <div className="w3-container w3-padding">
        <h4><i className="fa fa-group w3-text-theme w3-margin-right"></i>Team Setup</h4>

        {isLocked && (
          <div className="w3-panel w3-pale-yellow w3-leftbar w3-border-amber w3-round" style={{ padding: '8px 12px', marginBottom: '16px' }}>
            <i className="fa fa-lock w3-margin-right"></i>
            <strong className="w3-small">Competition {isFinalised ? 'finalised' : 'reopened for score fixes only'}</strong>
            <span className="w3-small"> — {isFinalised ? 'reopen from the Results tab to make changes' : 'team changes are locked'}</span>
          </div>
        )}

        {/* Action buttons */}
        {!isLocked && (
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '16px', alignItems: 'center' }}>
          {(selectedComp.format === 'singles' || selectedComp.teamAssignment === 'auto-random' || selectedComp.teamAssignment === 'auto-rated') && (
            <button className="w3-button w3-theme w3-round" onClick={generateTeams}>
              <i className={`fa ${(teams.length > 0) ? 'fa-refresh' : (selectedComp.teamAssignment === 'auto-rated' ? 'fa-balance-scale' : 'fa-random')} w3-margin-right`}></i>
              {teams.length > 0
                ? (selectedComp.teamAssignment === 'auto-rated' ? 'Re-generate (Rated)' : 'Re-generate')
                : (selectedComp.teamAssignment === 'auto-rated' ? 'Auto-Generate (Rated)' : 'Auto-Generate')}
            </button>
          )}
          {/* Neither of these two rows has a fixed width. They had one each —
              a 300px name box, a 180px list and a label told never to wrap —
              so on a phone they could not shrink, and Create went off the
              right-hand edge of the screen. Now each takes the line it needs
              and wraps under the other when there is not room for both. */}
          {importableClubTeams.length > 0 && (
            <div style={{ display: 'flex', gap: '4px 8px', alignItems: 'center', flexWrap: 'wrap', flex: '1 1 320px', minWidth: 0, maxWidth: '560px' }}>
              <span className="w3-small w3-text-grey">Add existing team profile from club database:</span>
              <select className="w3-select w3-border w3-round w3-small" style={{ flex: '1 1 180px', minWidth: 0 }}
                value="" onChange={e => importClubTeam(e.target.value)}>
                <option value="">Select club team...</option>
                {importableClubTeams.map(ct => {
                    const active = (ct.Users || []).filter(u => u.ClubTeamPlayer && u.ClubTeamPlayer.active).length;
                    return <option key={ct.id} value={ct.id}>{ct.name} ({active} players)</option>;
                  })}
              </select>
            </div>
          )}
          <div style={{ display: 'flex', gap: '4px', flex: '1 1 320px', minWidth: 0, maxWidth: '480px' }}>
            <input className="w3-input w3-border w3-round" placeholder="New team name" value={newTeamName}
              aria-label="Name of a new team to add to this competition"
              onChange={e => setNewTeamName(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && createTeam()}
              style={{ flex: '1 1 auto', minWidth: 0 }} />
            <button className="w3-button w3-theme-d1 w3-round" style={{ flex: 'none', whiteSpace: 'nowrap' }} onClick={createTeam}>
              <i className="fa fa-plus"></i> Create
            </button>
          </div>
          {selectedCompDiscipline && clubTeams.length > 0 && importableClubTeams.length === 0 && (
            <span className="w3-small w3-text-grey">
              No {selectedCompDiscipline} club teams available to import.
            </span>
          )}
        </div>
        )}

        {/* Unassigned banner */}
        {(selectedComp.format === 'singles' || selectedComp.teamAssignment === 'auto-random' || selectedComp.teamAssignment === 'auto-rated') && availableForTeam.length > 0 && (
          <div className="w3-panel w3-pale-yellow w3-leftbar w3-border-amber w3-round" style={{ padding: '8px 12px' }}>
            <strong className="w3-small">Unassigned ({availableForTeam.length}):</strong>{' '}
            <span className="w3-small">{availableForTeam.map(p => p.name).join(', ')}</span>
          </div>
        )}

        {/* Team cards */}
        {teams.length === 0 ? (
          <p className="w3-text-grey w3-center"><em>No teams yet. Auto-generate or create manually.</em></p>
        ) : (
          <div className="team-grid">
            {teams.map(t => {
              const isEditing = editingTeam === t.id;
              return (
                <div key={t.id} className="w3-card w3-round team-card">
                  <div className="w3-container w3-theme-l4 w3-round-top" style={{ padding: '8px 12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    {t.ClubTeamId ? (
                      <strong style={{ cursor: 'pointer' }} onClick={() => openTeamProfile(t.ClubTeamId)} title="View team profile">
                        {t.name} <i className="fa fa-external-link w3-tiny w3-text-grey"></i>
                      </strong>
                    ) : !isLocked && isEditing ? (
                      <input className="w3-input w3-border w3-round w3-small" style={{ width: '140px' }}
                        defaultValue={t.name} autoFocus
                        onBlur={e => renameTeam(t.id, e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && renameTeam(t.id, e.target.value)} />
                    ) : (
                      <strong style={{ cursor: isLocked ? 'default' : 'pointer' }} onClick={() => !isLocked && setEditingTeam(t.id)} title={isLocked ? '' : 'Click to rename'}>
                        {t.name} {!isLocked && <i className="fa fa-pencil w3-tiny w3-text-grey"></i>}
                      </strong>
                    )}
                    {!isLocked && (
                    <button className="w3-button w3-tiny w3-hover-red w3-round" onClick={() => deleteTeam(t.id)} title="Delete" aria-label="Delete">
                      <i className="fa fa-trash"></i>
                    </button>
                    )}
                  </div>
                  <div className="w3-container" style={{ padding: '8px 12px' }}>
                    {t.Users && t.Users.length > 0 ? (
                      <ul className="w3-ul w3-small" style={{ margin: 0, padding: 0 }}>
                        {t.Users.map(u => {
                          const isActiveInClub = clubTeams.some(ct =>
                            (ct.Users || []).some(cu => cu.id === u.id && cu.ClubTeamPlayer && cu.ClubTeamPlayer.active)
                          );
                          const cp = compPlayers.find(p => p.id === u.id);
                          const paid = cp ? cp.hasPaid : false;
                          return (
                            <li key={u.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', border: 'none' }}>
                              <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                {isAdmin && (
                                  <i className={`fa ${paid ? 'fa-check-circle w3-text-green' : 'fa-circle-o w3-text-grey'}`}
                                    title={paid ? 'Paid — click to mark unpaid' : 'Unpaid — click to mark paid'}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => togglePaid(u.id)}></i>
                                )}
                                <i className={`fa fa-user ${isActiveInClub ? 'w3-text-theme' : 'w3-text-orange'}`}></i>
                                {u.name}
                                {!isActiveInClub && (
                                  <span className="w3-tag w3-round w3-orange w3-tiny" style={{ marginLeft: '6px', padding: '1px 6px' }}>inactive</span>
                                )}
                              </span>
                              {!isLocked && (
                              <button className="w3-button w3-tiny w3-hover-red" onClick={() => removePlayerFromTeam(t.id, u.id)}>
                                <i className="fa fa-times"></i>
                              </button>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    ) : (
                      <p className="w3-small w3-text-grey" style={{ margin: '4px 0' }}><em>No players</em></p>
                    )}
                    {!isLocked && (() => {
                      const ppt = selectedComp.playersPerTeam || 1;
                      const currentCount = (t.Users || []).length;
                      if (currentCount >= ppt) return null;
                      const pool = selectedComp.format !== 'singles'
                        ? users.filter(u => !assignedPlayerIds.includes(u.id))
                        : availableForTeam;
                      return pool.length > 0 && (
                        <div style={{ marginTop: '6px' }}>
                          <select className="w3-select w3-border w3-round w3-small" style={{ flex: 1 }}
                            value={teamPlayerPick} onChange={e => {
                              const val = e.target.value;
                              setTeamPlayerPick(val);
                              if (val) addPlayerToTeam(t.id, val);
                            }}>
                            <option value="">Add player ({currentCount}/{ppt})...</option>
                            {pool.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                          </select>
                        </div>
                      );
                    })()}
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {emailPanel}

        {/* Nav buttons */}
        <div style={{ display: 'flex', justifyContent: selectedComp.format === 'singles' ? 'space-between' : 'flex-end', marginTop: '16px', paddingBottom: '4px' }}>
          {selectedComp.format === 'singles' && (
            <button className="w3-button w3-theme-l4 w3-round" onClick={() => setActiveStep('players')}>
              <i className="fa fa-arrow-left w3-margin-right"></i>Back
            </button>
          )}
          <button className="w3-button w3-theme w3-round-large" onClick={() => setActiveStep('fixtures')} disabled={teams.length < 2}>
            Next: Generate Draw <i className="fa fa-arrow-right w3-margin-left"></i>
          </button>
        </div>
      </div>
    </div>
  );
}

export default CompetitionTeams;
